(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgNavigation', sgNavigation);

  sgNavigation.$inject = ['$window', '$timeout', '$mdSidenav'];

  function sgNavigation ($window, $timeout, $mdSidenav) {

    return {
      templateUrl: 'app-legacy/components/sg-navigation/sg-navigation.html',
      restrict: 'E',
      // replace true is needed for easier css selectors like .sg-main-menu + .sg-page
      replace: true,
      controller: 'sgNavigationCtrl',
      controllerAs: 'navCtrl',
      link: function (scope, element, attrs, ctrl) {
        scope.openLeftMenu = function () {
          if (ctrl.isLoggedIn) {
            $mdSidenav('leftmenu').open();
          }
        };

        scope.closeLeftMenu = function () {
          if (ctrl.isLoggedIn) {
            $mdSidenav('leftmenu').close();
          }
        };
      }
    };
  };


})();
